import React, { FC } from 'react';
import { Divider, Stack } from '@mui/material';
import useTranslation from '../../../hooks/useTranslation';
import CustomNumberInput from '../../../common/CustomNumberInput';
import { EditFinancesBlockProps } from './EditFinancesBlockProps';
const EditFinancesBlock: FC<EditFinancesBlockProps> = ({
  currency,
  currencyRate,
  label,
  name,
}) => {
  const t = useTranslation();
  return (
    <Stack pb={5} spacing={3}>
      <Divider />
      <CustomNumberInput
        label={t(`projects.properties.${label}.budget`)}
        currencySymbol={currency}
        currencyRate={currencyRate}
        name={`total${name}Budget`}
        dataTestID={`total-${label}-budget`}
        disabled
      />
      <CustomNumberInput
        label={t(`projects.properties.${label}.forecast`)}
        currencySymbol={currency}
        currencyRate={currencyRate}
        name={`total${name}Forecast`}
        dataTestID={`total-${label}-forecast`}
        disabled
      />
      <CustomNumberInput
        label={t(`projects.properties.${label}.releasedApproved`)}
        currencySymbol={currency}
        currencyRate={currencyRate}
        name={`total${name}ReleasedApproved`}
        dataTestID={`total-${label}-released-approved`}
        disabled
      />
      <CustomNumberInput
        label={t(`projects.properties.${label}.pToolForecast`)}
        currencySymbol={currency}
        currencyRate={currencyRate}
        name={`total${name}PToolForecast`}
        dataTestID={`total-${label}-ptool-forecast`}
        disabled
      />
      <CustomNumberInput
        label={t(`projects.properties.${label}.actuals`)}
        currencySymbol={currency}
        currencyRate={currencyRate}
        name={`total${name}Actuals`}
        dataTestID={`total-${label}-actuals`}
        disabled
      />
    </Stack>
  );
};

export default EditFinancesBlock;
